import React from "react";

import {
  Paper,
  Card,
  Box,
  Typography,
} from "@mui/material";

import {
  AccountTree,
  PendingActions,
  PointOfSale,
  ShoppingCart,
  ReceiptLong,
  Payments,
  Balance,
  TrendingUp,
  AccountBalance,
} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";

export default function AccountsReportsDashboard() {

  const navigate = useNavigate();

  const reports = [

    {
      title: "Ledger Statement",
      desc: "All ledger reports",
      icon: <AccountTree />,
      path: "/accountant/ledger-statement",
    },

    {
      title: "Outstanding Statement",
      desc: "Pending customer invoices",
      icon: <PendingActions />,
      path: "/accountant/outstanding-statement",
    },

    {
      title: "Sales Register",
      desc: "Invoice summary",
      icon: <PointOfSale />,
      path: "/accountant/sales-register",
    },

    {
      title: "Purchase Register",
      desc: "Purchase summary",
      icon: <ShoppingCart />,
      path: "/accountant/purchase-register",
    },

    {
      title: "Receipt Register",
      desc: "Receipt vouchers",
      icon: <ReceiptLong />,
      path: "/accountant/receipt-register",
    },

    {
      title: "Payment Register",
      desc: "Payment vouchers",
      icon: <Payments />,
      path: "/accountant/payment-register",
    },

    {
      title: "Trial Balance",
      desc: "Accounting balance",
      icon: <Balance />,
      path: "/accountant/trial-balance",
    },

    {
      title: "Profit & Loss",
      desc: "Income & expense",
      icon: <TrendingUp />,
      path: "/accountant/profit-loss",
    },

    {
      title: "Balance Sheet",
      desc: "Financial position",
      icon: <AccountBalance />,
      path: "/accountant/balance-sheet",
    },

  ];

  return (

    <Paper sx={{ p: 3 }}>

      <Typography
        variant="h5"
        fontWeight={700}
        mb={3}
      >
        Accounts Reports
      </Typography>

      <Box
        sx={{
          display: "grid",

          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(4, 1fr)",
          },

          gap: 3,
        }}
      >

        {reports.map((r, i) => (

          <Card
            key={i}

            onClick={() => navigate(r.path)}

            sx={{
              minHeight: 110,

              borderRadius: 2,

              boxShadow: 1,

              display: "flex",
              alignItems: "center",

              gap: 2,

              p: 2,

              cursor: "pointer",

              transition: "0.2s",

              "&:hover": {
                boxShadow: 4,
                transform: "translateY(-2px)",
              },
            }}
          >

            <Box
              sx={{
                width: 52,
                height: 52,

                borderRadius: 2,

                background: "#e8f1ff",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                color: "#1a73e8",

                flexShrink: 0,
              }}
            >
              {r.icon}
            </Box>

            <Box sx={{ overflow: "hidden" }}>

              <Typography
                fontWeight={700}
                noWrap
              >
                {r.title}
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
              >
                {r.desc}
              </Typography>

            </Box>

          </Card>

        ))}

      </Box>

    </Paper>

  );
}